export const PROJECT_NAME_LABEL = "project.creation.name.label";
export const PROJECT_NAME_PREFIX = "project.creation.name.prefix";
